// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"hsmd48Ci","title":"_3eLGOmt4","titleLoggedIn":"_3xy9-j3W","description":"_2bCGm3g7"};